/* global localStorage */
import { logoutAPI } from "../api/authAPI";
export const logoutCall = (token) => {
  localStorage.removeItem("auth");
  logoutAPI(token);
};
